"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _recompose = require("../recompose");
var _router = require("../router");
var _tracker = _interopRequireDefault(require("./tracker"));
var withRouterTracking = (0, _recompose.compose)(_router.withRouter, (0, _recompose.lifecycle)({
  componentDidMount: function componentDidMount() {
    _tracker.default.push({
      event: 'pageview'
    });
  },
  componentDidUpdate: function componentDidUpdate(_ref) {
    var location = _ref.location;
    if (this.props.location.pathname !== location.pathname) {
      _tracker.default.push({
        event: 'pageview'
      });
    }
  }
}));
var _default = exports.default = withRouterTracking;